import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Resets the scroll position on route change.
 *
 * This MUST be instant. `index.css` sets `* { scroll-behavior: smooth }`, so a
 * plain `window.scrollTo(0, 0)` animates the viewport up through the whole
 * page — and that sweep fires every IntersectionObserver-based reveal on the
 * way past, so the new page arrives with all of its scroll animations already
 * spent (scrolling down it then looks static).
 *
 * `behavior: "instant"` is the only thing that reliably bypasses a CSS
 * `scroll-behavior: smooth` — `"auto"` still animates, and so does assigning
 * `scrollTop` directly.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant" as ScrollBehavior,
    });
  }, [pathname]);

  return null;
}
